import React from 'react'
import { Category, Size } from '@/api'
import { genderOptions } from '../constants'

interface ListingsHeaderProps {
  title: string
  itemCount: number
  categories?: Category[]
  sizes?: Size[]
  selectedGender: string
  selectedCategories: string[]
  selectedSizes: string[]
  keyword?: string
}

export const ListingsHeader = ({
  title,
  itemCount,
  categories,
  sizes,
  selectedGender,
  selectedCategories,
  selectedSizes,
  keyword,
}: ListingsHeaderProps) => {
  const genderLabel = selectedGender
    ? genderOptions.find((option) => option.id === selectedGender)?.label
    : ''

  const categoryLabels = categories
    ? categories
        .filter((category) => selectedCategories.includes(category.id))
        .map((category) => category.name)
    : []

  const sizeLabels = sizes
    ? sizes
        .filter((size) => selectedSizes.includes(size.id))
        .map((size) => size.name)
    : []

  const displayTitle =
    [
      ...(keyword ? [keyword] : []),
      ...(genderLabel ? [genderLabel] : []),
      ...categoryLabels,
      ...sizeLabels,
    ].join(' / ') || title

  return (
    <div className="pt-4 pb-3 md:pt-6">
      <h2 className="text-[18px] md:text-2xl font-bold mb-1">{displayTitle}</h2>
      <span className="text-xs">{itemCount} items</span>
    </div>
  )
}
